/**
 * Friendly Wall-E style robot icon.
 * Single big camera eye, curved antenna, rounded oval head.
 * Stroke inherits parent color via `stroke` prop; `fill` controls eye highlight.
 */
export default function RobotIcon({ size = 22, stroke = "currentColor", strokeWidth = 2, fill = "currentColor", className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Curved antenna (small arc up-left ending in a filled bulb) */}
      <path d="M16 8 C 16 5, 14 4, 12 3" />
      <circle cx="11.5" cy="2.5" r="1.4" fill={fill} stroke="none" />

      {/* Rounded head (oval) */}
      <rect x="5" y="8" width="22" height="17" rx="6" ry="6" />

      {/* Big camera eye (lens) */}
      <circle cx="16" cy="16" r="6" />
      {/* Inner iris (filled) */}
      <circle cx="16" cy="16" r="2.6" fill={fill} stroke="none" />
      {/* Highlight dot */}
      <circle cx="17.7" cy="14.4" r="0.9" fill="#FFFFFF" stroke="none" />

      {/* Tiny smile under the eye */}
      <path d="M13 22 Q 16 24, 19 22" />

      {/* Small body hint at bottom */}
      <path d="M11 25 L 11 28" />
      <path d="M21 25 L 21 28" />
      <path d="M9 28 L 23 28" />
    </svg>
  );
}
